export const handleRedirectToLogin = async (authDataStore, to, next) => {
  await authDataStore.fetchAuthData();

  if (authDataStore.authData.isLoggedIn === false) {
    localStorage?.setItem('redirectRoute', JSON.stringify(to));
    next({ name: 'login' });
  }
};
